console.log('noew try ')







jQuery(function($) {







    $(document).on("click", ".logo-popup__close" , function() {



        $('.modal--logo-popup').attr("aria-hidden","true");



          if(window.location.href.includes("/cart")){



            window.location.reload();



          }



    });







    $(document).on("click", ".continue-logo-preview" , function() {



        $('.modal--logo-popup').attr("aria-hidden","true");



          if(window.location.href.includes("/cart")){



            window.location.reload();



          }



    });



  if($('.custom-qty').length > 0){



    $('.custom-qty').each(function(){



      var thelabel = $(this).find('label')



     if(thelabel.text().toLowerCase() == '1 size'){



         thelabel.text('Qty')



       }



    })



  }



    var zoomSlider = '';



    function destroyZoomImages(){



        $('#product-zoom-contents').empty();



  }



    function setupZoomImages(state){



        var img_block = ''; 



        $('#main-gallery img').each(function(){



            var img = $(this).attr('src')



            if(img.includes('cloudinary')){



            }



            // else if($(this).attr('alt').includes('no-logo')){



            // }



            else{



              var img = $(this).attr('data-zoom')



            }



            img_block += '<div class="img-container"><img src="'+ img +'" /></div>';



      })



        $('#product-zoom-contents').append(img_block)







        // zoomSlider = $('#product-zoom-contents').flickity({



        //   "lazyLoad": 2,



        //   "imagesLoaded": true,



        //   "draggable": true,



        //   "prevNextButtons": true,



        //   "wrapAround": true,



        //   "cellAlign": 'center',



        //   "pageDots": false,



        //   "contain": true,



        //   "freeScroll": true,



        //   "initialIndex": 1



        // });



    } 



    var logoMover =  '<div class="logo-mover"><button class="up">↑</button><button class="right">→</button><button class="down">↓</button><button class="left">←</button> <p class="small-mover-text">Adjust Logo</p></div>'



    var logoMoverPlaced = true; 



    var selectedShirt;



    var selectedShirtImg;







    //Configure & Init Cloudinary



    var loadedLogo = {



        original_size: {



            height: "auto",



            width: "auto"



        },



        transformed_size: {



            height: 0,



            width: 0,



            base_width: 0,



            scale: 1



        },



        url: undefined,



        secure_url: undefined,



        scalable_image_url: undefined,



        public_id: undefined,



        original_filename: undefined,



        desktop_product_url: undefined,



        desktop_zoom_product_url: undefined,



        composition_url_desktop: undefined,



        composition_url_desktop_zoom: undefined,



        img_real_width: undefined,



        img_real_height: undefined,



        proof_number: undefined



    };







    var setLogoData = function(data) {



        for (var key in data) {



            if (loadedLogo.hasOwnProperty(key) && data.hasOwnProperty(key)) {



                loadedLogo[key] = data[key];



            }



        }



        return loadedLogo;



    };











    var cloudinaryConfig = {



        api_key: "542581144251298",



        cloud_name: "threadlogic-com",



        upload_preset: "esfwmkjo",



        secure: true



    };







    $.cloudinary.config(cloudinaryConfig);







    var formData = {



        upload_preset: cloudinaryConfig.upload_preset



    };







    $("input.cloudinary-fileupload[type=file]").attr('data-form-data', JSON.stringify(formData));







    //Configure & Init Cloudinary



















    //Process Logos & Shirts







    function insertLogoMover(){



    //product_gallery



        if(!logoMoverPlaced){



            setTimeout(function(){



              $('.product-gallery__carousel-wrapper').append(logoMover) 



              logoMoverPlaced = true;



            })        



        }



    }



    function isNumber(n) {



      return !isNaN(parseFloat(n)) && isFinite(n);



    }



    function createLogoOverlay(productImgUrl, logoCloudinaryId, position) {



        console.log(productImgUrl)



      console.log(logoCloudinaryId);



      console.log("_logoPositionX", _logoPositionX);



      console.log("_logoPositionY", _logoPositionY);



      console.log("_logoMaxWidth", _logoMaxWidth);



      console.log("_logoMaxHeight", _logoMaxHeight);







        if (loadedLogo.img_real_width == undefined || loadedLogo.img_real_height == undefined) {



            console.log('Image real width or height is not defined. Cannot generate the image composition');



            return;



        }



        var logoYposition = 120;



    var logo_offset_val = $("#logo_offset_value").val().toLowerCase();



        if(logo_offset_val == 'big_hood_offset'){



          logoYposition = 250;



        }



        else if(logo_offset_val == 'small_hood_offset'){



            logoYposition = 200;



        }



            else if(logo_offset_val == 'quarter_zip_offset'){



            logoYposition = 150;



        }



        else{



          if(isNumber(logo_offset_val)){



            console.log(logo_offset_val)



            logoYposition  = logo_offset_val



          }



        }



        var logoXposition = 140;



        if(position == 'left'){



          logoXposition = 140



        }



        if(position == 'right'){



          logoXposition = 290



        }



        var realW = loadedLogo.img_real_width;



        var realH = loadedLogo.img_real_height;



        var logoRealW = loadedLogo.original_size.width;



        var logoRealH = loadedLogo.original_size.height;



        var logoW = parseInt((240 / 100) * realW);







        var scale = loadedLogo.transformed_size.scale;



        if (logoRealW > logoRealH) {



            imgW = Math.round(logoW * scale)



            var auxScale = imgW / logoRealW;



            imgH = Math.round(logoRealH * auxScale);



        } else {



            imgH = Math.round(logoW * scale);



            var auxScale = imgH / logoRealH;



            imgW = Math.round(logoRealW * auxScale);



        }







        var hardWidth = 70;



        var hardHeight = 40;



        var gravity = 'north_east'







        if(position == 'center'){







            gravity = 'center';



            hardWidth = 600;



            hardHeight = 300;



            logoXposition = 0



            logoYposition = -60







            if(logo_offset_val == 'small_hat_offset'){



                logoYposition = 0



                hardWidth = 250;



                hardHeight = 125;



            }



            else if(logo_offset_val == 'beanie_offset'){ 



                logoYposition = 350



                hardWidth = 540;



                hardHeight = 270;



                // gravity = 'south';



            }



            else if(logo_offset_val == 'small_beanie_offset'){ 



                logoYposition = 100



                hardWidth = 270;



                hardHeight = 100;



                // gravity = 'south';



            }







        }







        // Convert percentage values



        var x = 40;



        var y = 40;



        if (imgW < logoW) {



            x += Math.round((logoW - imgW) / 2);



        }



        if (imgH < logoW) {



            y += Math.round((logoW - imgH) / 2);



        }



        if (productImgUrl && productImgUrl.trim() !== '' && logoCloudinaryId && logoCloudinaryId.trim() !== '') {



            var url = $.cloudinary.image(productImgUrl, {



                transformation: [{



                    width: (_logoMaxWidth >= 0) ? _logoMaxWidth : hardWidth,



                    height: (_logoMaxHeight >= 0) ? _logoMaxHeight : hardHeight,



                    crop: 'fit',



                    gravity: 'center',



                    overlay: new cloudinary.Layer().publicId(logoCloudinaryId),



                    effect: 'make_transparent:30',



                    },



                                 {



                    width: (_logoMaxWidth >= 0) ? _logoMaxWidth : hardWidth,



                    height: (_logoMaxHeight >= 0) ? _logoMaxHeight : hardHeight,



                    crop: 'pad',



                    gravity: 'center',



                    format: 'png'},



                                 {flags: "layer_apply", 



                                  gravity: _logoGravity ? _logoGravity : gravity,



                    x: (_logoPositionX > -1000) ? _logoPositionX : logoXposition,



                    y: (_logoPositionY > -1000) ? _logoPositionY : logoYposition



                }],



                type: "fetch"



            });







            var url_src = url.attr('src');







            //console.log(url_src)







            return url_src;



        }



        return false;



    };











    function saveToStorage(key, logo) {



        localStorage.setItem(key, logo);



    }







    function getFromStorage(key) {



        return localStorage.getItem(key);



    }



var uploadLaterOrderNote = 'LOGO STATUS: Customer will send logo later.';







function updateUploadLaterOrderNote(addNote) {







    return fetch('/cart.js', {



        credentials: 'same-origin'



    })



    .then(function(response) {



        return response.json();



    })



    .then(function(cart) {







        var existingNote = cart.note || '';







        // Break existing note into lines and remove only our exact internal status line



        var noteLines = existingNote.split(/\r?\n/).filter(function(line) {



            return line.trim() !== uploadLaterOrderNote;



        });







        // Add our status line back to the top when Upload Later is selected



        if (addNote) {



            noteLines.unshift(uploadLaterOrderNote);



        }







        var newNote = noteLines



            .join('\n')



            .replace(/\n{3,}/g, '\n\n')



            .trim();







        return fetch('/cart/update.js', {



            method: 'POST',



            credentials: 'same-origin',



            headers: {



                'Content-Type': 'application/json',



                'X-Requested-With': 'XMLHttpRequest'



            },



            body: JSON.stringify({



                note: newNote



            })



        })



        .then(function(response) {



            return response.json();



        })



        .then(function(updatedCart) {







            // Keep any visible cart note fields synchronized



            if (document.getElementById('noteTextarea')) {



                document.getElementById('noteTextarea').value = newNote;



            }







            if (document.getElementById('order-note-textarea')) {



                document.getElementById('order-note-textarea').value = newNote;



            }







            return updatedCart;



        });







    });







}



    function setLogoDataFromSession(logoUrl, img_real_width, img_real_height, current_image_url) {







        var secure_url = getFromStorage('logo_secure_url')



        var scalable_url = getFromStorage('logo_scalable_image')



        var public_id = getFromStorage('logo_id')



        var original_filename = getFromStorage('logo_original_filename')



        $('.logo-filename').text('Your Logo: ');



        $('#custom_logo_url').html('<img src="'+scalable_url+'" alt="Logo" width=50 height=50 />');



        $('.existing-logo').addClass('active');



        $('.logo-upload span').text('Change Logo');



        $('.no-logo-panel').addClass('hide');



        $('.cart-logo-wrapper').html('<a target="_blank" style="text-decoration:underline;" href="'+secure_url+'" rel="noopener" aria-describedby="a11y-new-window-message"><img id="order_logo_img" src="'+secure_url+'" style="margin: 10px auto 30px auto; width:auto;display:block;"></a>'+



'    <button type="button" class="cart-recap__note-button" data-action="toggle-collapsible" data-collapsible-force-overflow="" aria-controls="order-note" aria-expanded="true">Order Notes<span>'+



'            <span class="cart-recap__note-edit ">Edit</span><svg focusable="false" class="icon icon--arrow-bottom " viewBox="0 0 12 8" role="presentation">'+



'      <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>'+



'    </svg></span>'+



'    </button>'+



'    <div id="order-note" aria-hidden="false">'+



'        <div class="cart-recap__note-inner">'+



'            <textarea id="noteTextarea" name="note" class="form__field form__field--textarea" rows="3">'+mwProductFeesObjects?.cart?.note+'</textarea>'+



'            <button id="saveButton" type="button" class="form__submit form__submit--tight button button--secondary" data-action="save-note">Save</button>'+



'        </div>'+



'    </div>');



        ////$('.cloudinary-fileupload').hide();



        setLogoData({



            original_size: {



                height: 80,



                width: 80



            },



            url: logoUrl,



            secure_url: secure_url,



            scalable_image_url: scalable_url,



            public_id: public_id,



            original_filename: original_filename,



            img_real_width: img_real_width,



            img_real_height: img_real_height,



        });











            fetch("/cart/update.js", {



              body: JSON.stringify({



                attributes: {



                  'order_logo': secure_url



                }



              }),



              credentials: 'same-origin',



              method: 'POST',



              headers: {



                'Content-Type': 'application/json',



                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header



              }



            });



    }







    function updateLogoData(logoUrl, selectedShirtImg) {







        var img_real_width = $(selectedShirtImg).width()







        var img_real_height = $(selectedShirtImg).height()



        // var current_image_url = 'https:' + $('.product-gallery__carousel-item.is-selected img').attr('data-zoom')



        var current_image_url = 'https:' + $('.product-gallery__carousel-item.is-selected img').attr('data-logo-img')







        setLogoDataFromSession(logoUrl, img_real_width, img_real_height, current_image_url)







    }







    function updateProductImage() {



        var logoId = getFromStorage('logo_id')







        if (logoId === null) {



            console.log('null')



            return;



        }







        setTimeout(function() {



            //Selected Shirt



            $('.product-gallery__carousel-item.is-selected img')







            var position = 'left';



            if($(selectedShirtImg) && $(selectedShirtImg).attr('alt').includes('logo-right')){



              position = 'right'    



            }







            if($('#logo-hat-product').val() == 1){



                position = 'center';



            }



            var shirt_src = 'https:' + $(selectedShirtImg).attr('src')







            if (shirt_src.includes('cloudinary')) {



                return;



            }







            var new_logo_img_url = createLogoOverlay(shirt_src, logoId, position)











            $(selectedShirtImg).parent().empty().append("<img data-zoom='" + $(selectedShirtImg).attr('data-zoom') + "' src='" + new_logo_img_url + "' class='appear lazyautosizes lazyloaded' />");











        }, 250)







    }



    function resetAllProductImages() {



        var kk = 0;







        $('.product_gallery .flickity-slider .gallery-cell').each(function() {







            selectedShirtImg = $(this).find('.image__container img')



            var shirt_src = 'https:' + $(selectedShirtImg).attr('data-zoom')          



            $(selectedShirtImg).parent().empty().append("<img alt='"+ $(selectedShirtImg).attr('alt') + "' data-zoom='" + $(selectedShirtImg).attr('data-zoom') + "' src='" + $(selectedShirtImg).attr('data-zoom') + "' class='appear lazyautosizes lazyloaded' />")     



        })



        if($('.no-custom-logo').length > 0){



        }



        else{



          setupZoomImages(1)



          insertLogoMover()



        }







    }







    function updateAllProductImages() {



        var logoId = getFromStorage('logo_id')







        if (logoId === null) {



            console.log('null')



            return;



        }







        var logo_url = getFromStorage('logo_url')







        var kk = 0;



updateLogoData(logo_url, '');



        // $('.product_gallery .flickity-slider .gallery-cell').each(function() {



        $(document).find('.product-gallery__carousel .flickity-slider .product-gallery__carousel-item').each(function() {







            selectedShirtImg = $(this).find('img')



            // var shirt_src = 'https:' + $(selectedShirtImg).attr('data-zoom')    



            var shirt_src = 'https:' + $(selectedShirtImg).attr('data-logo-img')    



          if($('.no-custom-logo').length > 0){



                updateLogoData(logo_url, selectedShirtImg)



                return;



            }



            var position = 'left';            







            if($(selectedShirtImg).attr('alt') && $(selectedShirtImg).attr('alt').includes('logo-right')){



              position = 'right'    



            }







            if($('#logo-hat-product').val() == 1){



                position = 'center';



            }







            if (shirt_src.includes('cloudinary') || $(selectedShirtImg).attr('alt').includes('no-logo')) {



                $(selectedShirtImg).addClass("dont-change")



                return                



            }



            else{



                updateLogoData(logo_url, selectedShirtImg)



                var new_logo_img_url = createLogoOverlay(shirt_src, logoId, position)







                $(selectedShirtImg).parent().empty().append("<img alt='"+ $(selectedShirtImg).attr('alt') + "' data-logo-img='"+$(selectedShirtImg).attr('data-logo-img')+"' data-zoom='" + $(selectedShirtImg).attr('data-zoom') + "' src='" + new_logo_img_url + "' class='appear lazyautosizes lazyloaded' />")                



            }







        })



        if($('.no-custom-logo').length > 0){



        }



        else{



          setupZoomImages(1)



         insertLogoMover()



        }







    }







    function checkStorageData() {



//      if($('.no-custom-logo').length > 0){



//           return;



//         }



        if (getFromStorage('logo_id')) {







            setTimeout(function() {



                setupZoomImages(0)



                if($('.no-custom-logo').length > 0){







                }



                else{







                  //$('.logo-upload-message').addClass('active')



                }



            }, 300)



        }



        else{



          setupZoomImages(0)



        }



    }



    //Process Logos & Shirts











    //Onload Functions



    checkStorageData()







    //Onload Functions











    //Change Events For Inputs 



    $('.upload-toggle').on('change', function() {



        if ($(this).hasClass('upload-show')) {



            $('.logo-upload').addClass('active')



        } else if ($(this).hasClass('upload-hide')) {



            $('.logo-upload').removeClass('active')



        } else {



            $('.logo-upload').removeClass('active')



        }



    })







    var maxFileSize = 5000000;







    if ($.fn.cloudinary_fileupload !== undefined) {



        $("input.cloudinary-fileupload[type=file]").cloudinary_fileupload({



            autoUpload: true,



            replaceFileInput: true,



            maxFileSize: maxFileSize,



            loadImageMaxFileSize: maxFileSize,



            acceptFileTypes: /(\.|\/)(gif|jpe?g|png|pdf|ai|eps|psd)$/i



        });







        $('.cloudinary-fileupload').bind('fileuploadsend', function(e, data) {



            console.log('file sending')



        })







        $('.cloudinary-fileupload').bind('fileuploadadd', function(e, data) {



            if (data.files[0].size < maxFileSize) {



                data.submit();



            } else {



                alert('sorry your file is too large')



            }



        })







        $('.cloudinary-fileupload').bind('cloudinarydone', function(e, data) {







            var result = data.result



            var index = result.secure_url.lastIndexOf(".")







            var logo_url = result.url



            var logo_path = result.path



            var logo_etag = result.etag



            var logo_pub_id = result.public_id



            var scalable_image_url = result.secure_url.substring(0, index + 1) + 'png';







            //    var current_image = $('.gallery-cell.is-selected .image__container img')      



            selectedShirtImg = $('.product-gallery__carousel-item.is-selected img')



            var position = 'left';







            if($(selectedShirtImg).length && $(selectedShirtImg).attr('alt').includes('logo-right')){



              position = 'right';  



            }



            if($('#logo-hat-product').val() == 1){



                position = 'center';



            }







            // var selectedShirtImgUrl = 'https:' + $(selectedShirtImg).attr('data-zoom')



            var selectedShirtImgUrl = 'https:' + $(selectedShirtImg).attr('data-logo-img')



            saveToStorage('logo_id', logo_pub_id)



            saveToStorage('logo_url', logo_url)



            saveToStorage('logo_original_filename', result.original_filename)



            saveToStorage('logo_scalable_image', scalable_image_url)



           saveToStorage('logo_secure_url', result.secure_url)







saveToStorage('logo_on_file', '')







localStorage.removeItem('logo_on_file');



localStorage.removeItem('logo_upload_later');



$('.logo-on-file').removeClass("selected");

$('.logo-upload-later').removeClass("selected");



// Customer has now supplied a real logo, so remove the Upload Later note.

updateUploadLaterOrderNote(false);



$('.no-logo-panel').addClass('hide');







            updateLogoData(logo_url, selectedShirtImg)



            if($('.no-custom-logo').val() == 1 || $('.no-custom-logo').val() == 1){



        console.log('stop')



                return;



            }







            // Keep original product photography untouched.
            // The interactive browser preview handles the visual logo overlay.
            destroyZoomImages()
            setupZoomImages()



            $('.logo-upload-message').addClass('active');



            $('.logo-preview img').attr("src", logo_url);



            $('.modal--logo-popup').attr("aria-hidden","false");











            fetch("/cart/update.js", {



              body: JSON.stringify({



                attributes: {



                  'order_logo': result.secure_url



                }



              }),



              credentials: 'same-origin',



              method: 'POST',



              headers: {



                'Content-Type': 'application/json',



                'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header



              }



            });



          if(window.location.href.includes("/cart")){



            $('.cart-item-order-logo').html('<img src="'+logo_url+'" alt="Logo" width="50" height="50" />');



            /////window.location.reload();



          }



        });







        //Change Events







    }







    function update_url_x_axis(dir){



        var img_ = $('.product-gallery__carousel-item.is-selected img')



        if($(img_).attr('alt').includes('no-logo')){



          return



        }



        var img_src = $(img_).attr('src')



        var img_arr = img_src.split('x_')



        var url_start = img_arr[0]



        var url_end_split = img_arr[1].split(',')



        if(url_end_split[0] == ''){



          url_end_split[0] = 0;



        }



        var cur_url_position = parseFloat(url_end_split[0])



        console.log(dir)



        console.log(cur_url_position)



        var url_new_x_position;



        if(dir == 'left'){



            if($('#logo-hat-product').val() == 1){



              url_new_x_position = (cur_url_position - 10)



            }



            else{



              url_new_x_position = (cur_url_position + 10)



            }



            //if(url_new_x_position > 180){ url_new_x_position = cur_url_position }



        }



        else if(dir == 'right'){



            if($('#logo-hat-product').val() == 1){



              url_new_x_position = (cur_url_position + 10)



            }



            else{



              url_new_x_position = (cur_url_position - 10)



            }



           //if(url_new_x_position < 100){ url_new_x_position = cur_url_position }



        }



        console.log(url_new_x_position)



        var url_end = url_end_split[1]



        var new_url = url_start + 'x_' + url_new_x_position + ',' + url_end



    $('.product-gallery__carousel-item.is-selected img').attr('src', new_url)      







    }



    function update_url_y_axis(dir){



       var img_ = $('.product-gallery__carousel-item.is-selected img')







       if($(img_).attr('alt').includes('no-logo')){



         return



       }



        var img_src = $(img_).attr('src')



        var img_arr = img_src.split('y_')



        var url_start = img_arr[0]



        var url_end_split = img_arr[1].split('0/')



        if(url_end_split[0] == ''){



          url_end_split[0] = 0;



        }



    url_end_split[0] = parseFloat(url_end_split[0]) * 10



        var cur_url_position = parseFloat(url_end_split[0])



        if(dir == 'up'){                  



            var url_new_y_position = (cur_url_position - 10)



//             if(url_new_y_position < 100){ url_new_y_position = cur_url_position }



        }



        else if(dir == 'down'){



           var url_new_y_position = (cur_url_position + 10)



//            if(url_new_y_position > 160){ url_new_y_position = cur_url_position }



        }



        var url_end = url_end_split[1]



        var new_url = url_start + 'y_' + url_new_y_position + '/' + url_end       



    $('.product-gallery__carousel-item.is-selected img').attr('src', new_url)       



    }



    $('body').on('click', '.logo-mover button', function(e){



        e.preventDefault()







        if($(this).hasClass('up')){



          update_url_y_axis('up')



        }



        else if($(this).hasClass('right')){



          update_url_x_axis('right')          



      }



      else if($(this).hasClass('down')){



          update_url_y_axis('down')



      }



    else if($(this).hasClass('left')){



          update_url_x_axis('left')          



      }



    })



//     $('body').on('click', '#main-gallery .gallery-cell' ,function(e){



//      e.preventDefault();        



//         var selectedIndex = $(this).parent().find('.is-selected').index()



//         console.log(selectedIndex)



//         //$(zoomSlider).select(4)



//         zoomSlider.flickity( 'select', selectedIndex )



//    $('#product-zoom').addClass("active")



//  })



//     $('#product-zoom').on('click', function(e){



//        e.preventDefault();



//        var target = e.target



//         if($(target).hasClass('zoom-bg-close')){



//          $('#product-zoom').removeClass('active')    



//         }



//     })



    $('.clear-existing-logo').on('click', function(e){



        e.preventDefault();



        $('#custom_logo_url').val('')



        $('#custom_logo_file').val('')



        $('.logo-filename').text('')



        $('.existing-logo').removeClass('active')



        $('.logo-upload span').text('Upload Logo');



        $('.cloudinary-fileupload').show();



        $('.logo-mover').remove()



        localStorage.removeItem('logo_id')



        localStorage.removeItem('logo_url')



        localStorage.removeItem('logo_original_filename')



        localStorage.removeItem('logo_scalable_image')



        localStorage.removeItem('logo_secure_url')



        resetAllProductImages()



        $('.logo-upload-message').removeClass('active')



    });



   $('.logo-on-file button').on('click', function(e){







    e.preventDefault();







    $('.logo-on-file').addClass("selected");



    $('.logo-upload-later').removeClass("selected");







    $('#custom_logo_url').html(



        '<img src="' + window.logo_on_file + '" alt="Logo on File" width="50" height="50" />'



    );







    $('#custom_logo_file').val('');







    $('.logo-filename').text('');



    $('.existing-logo').removeClass('active');







    $('.logo-upload span').text('Upload Logo');



    $('.cloudinary-fileupload').show();







    $('.logo-mover').remove();







    // Clear uploaded logo data



    localStorage.removeItem('logo_id');



    localStorage.removeItem('logo_url');



    localStorage.removeItem('logo_original_filename');



    localStorage.removeItem('logo_scalable_image');



    localStorage.removeItem('logo_secure_url');







    // Clear Upload Later state



    localStorage.removeItem('logo_upload_later');







    // Save Logo on File state



    localStorage.setItem('logo_on_file', 'On File');







    $('.no-logo-panel').addClass('hide');







    resetAllProductImages();







    $('.logo-upload-message').removeClass('active');







    $(".cart-item-order-logo").html('');







    $(".cart-logo-wrapper").html(



        '<center>Logo On File</center>' +



        '    <button type="button" class="cart-recap__note-button" data-action="toggle-collapsible" data-collapsible-force-overflow="" aria-controls="order-note" aria-expanded="true">Order Notes<span>' +



        '            <span class="cart-recap__note-edit ">Edit</span><svg focusable="false" class="icon icon--arrow-bottom " viewBox="0 0 12 8" role="presentation">' +



        '      <path stroke="currentColor" stroke-width="2" d="M10 2L6 6 2 2" fill="none" stroke-linecap="square"></path>' +



        '    </svg></span>' +



        '    </button>' +



        '    <div id="order-note" aria-hidden="false">' +



        '        <div class="cart-recap__note-inner">' +



        '            <textarea id="noteTextarea" name="note" class="form__field form__field--textarea" rows="3">' + (mwProductFeesObjects?.cart?.note || '') + '</textarea>' +



        '            <button id="saveButton" type="button" class="form__submit form__submit--tight button button--secondary" data-action="save-note">Save</button>' +



        '        </div>' +



        '    </div>'



    );







    updateUploadLaterOrderNote(false)

    .then(function() {



        return fetch("/cart/update.js", {



            body: JSON.stringify({

                attributes: {

                    'order_logo': 'logo_file'

                }

            }),



            credentials: 'same-origin',

            method: 'POST',



            headers: {

                'Content-Type': 'application/json',

                'X-Requested-With': 'XMLHttpRequest'

            }



        });



    })

    .then(function(response) {



        console.log('LOGO ON FILE SAVED');



        if(window.location.href.includes("/cart")){

            window.location.reload();

        }



    });







});











$(document).on('click', '#upload-logo-later-button', function(e){



    e.preventDefault();



    console.log('UPLOAD LATER CLICKED');



    $('.logo-upload-later').addClass('selected');

    $('.logo-on-file').removeClass('selected');



    $('#custom_logo_url').html(

        '<img src="' + window.logo_upload_later + '" alt="Add Logo Later" width="50" height="50" />'

    );



    $('#custom_logo_file').val('');



    $('.logo-filename').text('');

    $('.existing-logo').removeClass('active');



    $('.logo-upload span').text('Upload Logo');

    $('.cloudinary-fileupload').show();



    $('.logo-mover').remove();



    // Clear any previously uploaded logo.

    localStorage.removeItem('logo_id');

    localStorage.removeItem('logo_url');

    localStorage.removeItem('logo_original_filename');

    localStorage.removeItem('logo_scalable_image');

    localStorage.removeItem('logo_secure_url');



    // Clear Logo on File and save Upload Later state.

    localStorage.removeItem('logo_on_file');

    localStorage.setItem('logo_upload_later', 'Yes');



    $('.no-logo-panel').addClass('hide');



    resetAllProductImages();



    $('.logo-upload-message').removeClass('active');



    $(".cart-item-order-logo").html(

        '<img src="' + window.logo_upload_later + '" alt="Add Logo Later" width="50" height="50" />'

    );



    // Add the internal service note first, then save the cart logo state.

    updateUploadLaterOrderNote(false)

    .then(function() {



        return fetch("/cart/update.js", {



            body: JSON.stringify({

                attributes: {

                    'order_logo': 'upload_later'

                }

            }),



            credentials: 'same-origin',

            method: 'POST',



            headers: {

                'Content-Type': 'application/json',

                'X-Requested-With': 'XMLHttpRequest'

            }



        });



    })

    .then(function(response) {



        console.log('UPLOAD LATER SAVED');



        if(window.location.href.includes("/cart")){

            window.location.reload();

        }



    });



});





if (getFromStorage('logo_on_file') == 'On File') {



    $('.logo-on-file').addClass("selected");



}







if (getFromStorage('logo_upload_later') == 'Yes') {



    $('.logo-upload-later').addClass("selected");



}







// Force show order note if it was previously hidden

document.getElementById('order-note')?.classList.remove('hidden');
document.getElementById('order-note')?.style.setProperty('display', 'block', 'important');


/* =========================================================
   INTERACTIVE PRODUCT LOGO PREVIEW
   Preview only — does NOT affect production placement
   ========================================================= */

const TL_PREVIEW_STANDARD_SIZE = 12;
const TL_PREVIEW_HAT_SIZE = 24;
const TL_PREVIEW_SIZE_MIN_MULTIPLIER = 0.75;
const TL_PREVIEW_SIZE_MAX_MULTIPLIER = 1.25;
const TL_PREVIEW_QUADRANT_SPLIT = 50;
const TL_PREVIEW_NUDGE_STEP = 1.5;
var tlLogoPreview = {
    active: false,
    initialized: false,
    x: 64,
    y: 36,
    width: TL_PREVIEW_STANDARD_SIZE
};


/* Does the customer have an actual uploaded logo? */
function tlHasUploadedLogo() {
    return !!(
        getFromStorage('logo_scalable_image') ||
        getFromStorage('logo_secure_url')
    );
}


/* Use uploaded logo; apply the same basic white-background removal concept. */
function tlGetPreviewLogoUrl() {
    var url =
        getFromStorage('logo_scalable_image') ||
        getFromStorage('logo_secure_url');

    if (!url) {
        return '';
    }

    if (
        url.indexOf('/upload/') !== -1 &&
        url.indexOf('e_make_transparent') === -1
    ) {
        url = url.replace(
            '/upload/',
            '/upload/e_make_transparent:30/'
        );
    }

    return url;
}


/* Get the currently selected product image. */
function tlGetSelectedProductImage() {
    var $item = $('.product-gallery__carousel-item.is-selected').first();

    if (!$item.length) {
        return null;
    }

    var $img = $item.find('img[data-logo-img]').first();

    if (!$img.length) {
        $img = $item.find('img').first();
    }

    if (!$img.length) {
        return null;
    }

    return {
        item: $item,
        img: $img
    };
}


/*
   Set the initial preview position.
   Standard left-chest embroidery = top-right of a front-facing photo.
   logo-right = top-left of a front-facing photo.
*/
function tlSetDefaultPreviewPosition() {
    var current = tlGetSelectedProductImage();
    var defaultSize = TL_PREVIEW_STANDARD_SIZE;

    tlLogoPreview.y = 36;

    if (!current) {
        tlLogoPreview.x = 64;
        tlLogoPreview.width = defaultSize;
    } else {
        var alt = (current.img.attr('alt') || '').toLowerCase();

        if ($('#logo-hat-product').val() == 1) {
            defaultSize = TL_PREVIEW_HAT_SIZE;
            tlLogoPreview.x = 50;
            tlLogoPreview.y = 48;
            tlLogoPreview.width = defaultSize;
        } else if (alt.indexOf('logo-right') !== -1) {
            // Wearer's RIGHT chest = left side of front-facing image.
            tlLogoPreview.x = 36;
            tlLogoPreview.width = defaultSize;
        } else {
            // Standard LEFT chest = right side of front-facing image.
            tlLogoPreview.x = 64;
            tlLogoPreview.width = defaultSize;
        }
    }

    var minSize = defaultSize * TL_PREVIEW_SIZE_MIN_MULTIPLIER;
    var maxSize = defaultSize * TL_PREVIEW_SIZE_MAX_MULTIPLIER;

    $('#tl-logo-preview-size')
        .attr('min', minSize)
        .attr('max', maxSize)
        .attr('step', 0.5)
        .val(tlLogoPreview.width);
}


/*
   Keep the entire logo inside the allowed decoration quadrant.
   Standard images: top-right quadrant.
   logo-right images: top-left quadrant.
   Hats remain unrestricted by chest-quadrant rules.
*/
function tlClampLogoPreviewPosition() {
    var current = tlGetSelectedProductImage();

    if (!current) {
        return;
    }

    if ($('#logo-hat-product').val() == 1) {
        return;
    }

    var $stage = $('.tl-logo-preview-stage').first();
    var $object = $('.tl-logo-preview-object').first();

    if (!$stage.length || !$object.length) {
        return;
    }

    var stageRect = $stage[0].getBoundingClientRect();
    var objectRect = $object[0].getBoundingClientRect();

    if (!stageRect.width || !stageRect.height) {
        return;
    }

    var halfWidth = (objectRect.width / stageRect.width) * 50;
    var halfHeight = (objectRect.height / stageRect.height) * 50;
    var alt = (current.img.attr('alt') || '').toLowerCase();

    var minX;
    var maxX;
    var minY = halfHeight;
    var maxY = TL_PREVIEW_QUADRANT_SPLIT - halfHeight;

    if (alt.indexOf('logo-right') !== -1) {
        // Top-left quadrant.
        minX = halfWidth;
        maxX = TL_PREVIEW_QUADRANT_SPLIT - halfWidth;
    } else {
        // Top-right quadrant.
        minX = TL_PREVIEW_QUADRANT_SPLIT + halfWidth;
        maxX = 100 - halfWidth;
    }

    // Defensive fallback for extremely wide/tall artwork.
    if (minX > maxX) {
        minX = maxX = alt.indexOf('logo-right') !== -1 ? 25 : 75;
    }

    if (minY > maxY) {
        minY = maxY = 25;
    }

    tlLogoPreview.x = Math.max(minX, Math.min(maxX, tlLogoPreview.x));
    tlLogoPreview.y = Math.max(minY, Math.min(maxY, tlLogoPreview.y));
}


/* Add preview controls below the entire product gallery. */
function tlEnsureLogoPreviewUI() {

    // Hide logo preview completely for products tagged "hide-logo-preview"
    if (window.tlHideLogoPreview === true) {
        $('#tl-logo-preview-tools').remove();
        return false;
    }

    if ($('#tl-logo-preview-tools').length) {
        return true;
    }

    var $gallery = $('.product-gallery__carousel-wrapper').first();

    if (!$gallery.length) {
        return false;
    }

    var previewTools = `
        <div id="tl-logo-preview-tools" class="tl-logo-preview-tools">
            <button
                type="button"
                id="tl-logo-preview-toggle"
                class="tl-logo-preview-toggle"
            >
                Preview your logo on this item →
            </button>

            <div
    id="tl-logo-preview-editor"
    class="tl-logo-preview-editor"
    hidden
>
                <div class="tl-logo-preview-control-row">
                    <label for="tl-logo-preview-size">
                        Logo Size
                    </label>

                    <input
                        id="tl-logo-preview-size"
                        type="range"
                        min="13.5"
                        max="22.5"
                        step="0.5"
                        value="18"
                    >

                    <button
                        type="button"
                        id="tl-logo-preview-reset"
                        class="tl-logo-preview-reset"
                    >
                        Reset
                    </button>
                </div>
<div class="tl-logo-preview-position-row">

    <span class="tl-logo-preview-position-label">
        Placement
    </span>

    <div
        class="tl-logo-preview-nudge-grid"
        role="group"
        aria-label="Adjust logo placement"
    >

        <button
            type="button"
            class="tl-logo-preview-nudge tl-logo-preview-nudge-up"
            data-direction="up"
            aria-label="Move logo up"
            title="Move logo up"
        >
            ↑
        </button>

        <button
            type="button"
            class="tl-logo-preview-nudge tl-logo-preview-nudge-left"
            data-direction="left"
            aria-label="Move logo left"
            title="Move logo left"
        >
            ←
        </button>

        <button
            type="button"
            class="tl-logo-preview-nudge tl-logo-preview-nudge-down"
            data-direction="down"
            aria-label="Move logo down"
            title="Move logo down"
        >
            ↓
        </button>

        <button
            type="button"
            class="tl-logo-preview-nudge tl-logo-preview-nudge-right"
            data-direction="right"
            aria-label="Move logo right"
            title="Move logo right"
        >
            →
        </button>

    </div>

</div>
               <div class="tl-logo-preview-help">
    Drag the logo or use the arrows to adjust placement. Use the slider to resize it.
</div>

                <div class="tl-logo-preview-disclaimer">
                    <strong>Preview only.</strong>
                    Final embroidery size and placement will follow our standard production specifications.
                </div>
            </div>
        </div>
    `;

    var $wholeGallery = $gallery.closest('.product-gallery');

    if ($wholeGallery.length) {
        $wholeGallery.after(previewTools);
    } else {
        $gallery.parent().after(previewTools);
    }

    return true;
}


/* Show/hide preview controls depending on logo status. */
function tlRefreshLogoPreviewAvailability() {
    if (!tlEnsureLogoPreviewUI()) {
        return;
    }

    var hasLogo = tlHasUploadedLogo();
    var usingLogoOnFile = getFromStorage('logo_on_file') === 'On File';
    var addingLater = getFromStorage('logo_upload_later') === 'Yes';

    if (hasLogo && !usingLogoOnFile && !addingLater) {
        $('#tl-logo-preview-tools').show();
    } else {
        $('#tl-logo-preview-tools').hide();
        tlClearInteractiveLogoPreview();
    }
}


/* Position the overlay stage directly over the visible product image. */
function tlSyncLogoPreview() {

    if (!tlLogoPreview.active) {
        return;
    }

    var current = tlGetSelectedProductImage();

    if (!current) {
        return;
    }

    var $img = current.img;
    var alt = ($img.attr('alt') || '').toLowerCase();

    if (alt.indexOf('no-logo') !== -1) {
        $('.tl-logo-preview-stage').remove();
        return;
    }

    $('.tl-logo-preview-stage').remove();

    /*
      Use the actual image container if present.
      This should match the same wrapper your old code used.
    */
    var $host = $img.closest('.image__container');

    if (!$host.length) {
        $host = $img.parent();
    }

    if (!$host.length) {
        return;
    }

    if ($host.css('position') === 'static') {
        $host.css('position', 'relative');
    }

    var logoUrl = tlGetPreviewLogoUrl();

    if (!logoUrl) {
        return;
    }

    var stage = `
        <div class="tl-logo-preview-stage">
            <div class="tl-logo-preview-object">
                <img
                    class="tl-logo-preview-image"
                    src="${logoUrl}"
                    alt="Logo preview"
                    draggable="false"
                >
            </div>
        </div>
    `;

    $host.append(stage);

    var $stage = $host.find('.tl-logo-preview-stage').last();

    /*
      Fill the host container directly.
      No manual rect math.
    */
    $stage.css({
        left: '0',
        top: '0',
        width: '100%',
        height: '100%'
    });

    tlApplyLogoPreviewState();

    var $previewImage = $stage.find('.tl-logo-preview-image');

    $previewImage.on('load', function() {
        tlClampLogoPreviewPosition();
        tlApplyLogoPreviewState();
    });

    requestAnimationFrame(function() {
        tlClampLogoPreviewPosition();
        tlApplyLogoPreviewState();
    });

}


/* Apply current X/Y/size to the draggable logo. */
function tlApplyLogoPreviewState() {
    $('.tl-logo-preview-object').css({
        left: tlLogoPreview.x + '%',
        top: tlLogoPreview.y + '%',
        width: tlLogoPreview.width + '%'
    });
}


function tlShowInteractiveLogoPreview() {
    if (!tlHasUploadedLogo()) {
        return;
    }

    tlLogoPreview.active = true;

    if (!tlLogoPreview.initialized) {
        tlSetDefaultPreviewPosition();
        tlLogoPreview.initialized = true;
    }

    $('#tl-logo-preview-editor').prop('hidden', false);
    $('#tl-logo-preview-toggle').text('Hide Logo Preview');
    tlSyncLogoPreview();
}


function tlHideInteractiveLogoPreview() {
    tlLogoPreview.active = false;
    $('.tl-logo-preview-stage').remove();
    $('#tl-logo-preview-editor').prop('hidden', true);
   $('#tl-logo-preview-toggle').text('Preview your logo on this item →');
}


function tlClearInteractiveLogoPreview() {
    tlHideInteractiveLogoPreview();
    tlLogoPreview.initialized = false;
    tlLogoPreview.x = 64;
    tlLogoPreview.y = 36;
    tlLogoPreview.width = TL_PREVIEW_STANDARD_SIZE;
}


/* Preview toggle. */
$(document).on('click', '#tl-logo-preview-toggle', function(e) {
    e.preventDefault();

    if (tlLogoPreview.active) {
        tlHideInteractiveLogoPreview();
    } else {
        tlShowInteractiveLogoPreview();
    }
});


/* Size slider: only 75%–125% of the default size. */
$(document).on('input change', '#tl-logo-preview-size', function() {
    tlLogoPreview.width =
        parseFloat($(this).val()) || TL_PREVIEW_STANDARD_SIZE;

    tlApplyLogoPreviewState();

    requestAnimationFrame(function() {
        tlClampLogoPreviewPosition();
        tlApplyLogoPreviewState();
    });
});


/* Reset to the default location and default size for this image. */
$(document).on('click', '#tl-logo-preview-reset', function(e) {
    e.preventDefault();
    tlSetDefaultPreviewPosition();
    tlSyncLogoPreview();
});
/* Fine-tune logo position with arrow buttons. */
$(document).on('click', '.tl-logo-preview-nudge', function(e) {

    e.preventDefault();

    if (!tlLogoPreview.active) {
        return;
    }

    var direction = $(this).data('direction');

    if (direction === 'up') {
        tlLogoPreview.y -= TL_PREVIEW_NUDGE_STEP;
    }

    if (direction === 'down') {
        tlLogoPreview.y += TL_PREVIEW_NUDGE_STEP;
    }

    if (direction === 'left') {
        tlLogoPreview.x -= TL_PREVIEW_NUDGE_STEP;
    }

    if (direction === 'right') {
        tlLogoPreview.x += TL_PREVIEW_NUDGE_STEP;
    }

    // Keep the logo inside the allowed placement area.
    tlClampLogoPreviewPosition();

    // Update the same preview used by dragging.
    tlApplyLogoPreviewState();

});

/* Drag logo with mouse or finger. */
$(document).on('pointerdown', '.tl-logo-preview-object', function(e) {
    if (!tlLogoPreview.active) {
        return;
    }

    e.preventDefault();

    var object = this;
    var stage = object.parentElement;

    if (!stage) {
        return;
    }

    var pointerEvent = e.originalEvent;
    var stageRect = stage.getBoundingClientRect();
    var objectRect = object.getBoundingClientRect();

    var centerX = objectRect.left + (objectRect.width / 2);
    var centerY = objectRect.top + (objectRect.height / 2);
    var offsetX = pointerEvent.clientX - centerX;
    var offsetY = pointerEvent.clientY - centerY;

    $(object).addClass('dragging');

    function moveLogo(ev) {
        ev.preventDefault();

        var newCenterX = ev.clientX - offsetX;
        var newCenterY = ev.clientY - offsetY;

        var x = ((newCenterX - stageRect.left) / stageRect.width) * 100;
        var y = ((newCenterY - stageRect.top) / stageRect.height) * 100;

        tlLogoPreview.x = x;
        tlLogoPreview.y = y;

        tlClampLogoPreviewPosition();
        tlApplyLogoPreviewState();
    }

    function stopDragging() {
        $(object).removeClass('dragging');

        document.removeEventListener('pointermove', moveLogo);
        document.removeEventListener('pointerup', stopDragging);
        document.removeEventListener('pointercancel', stopDragging);
    }

    document.addEventListener('pointermove', moveLogo, { passive: false });
    document.addEventListener('pointerup', stopDragging);
    document.addEventListener('pointercancel', stopDragging);
});


/* A newly uploaded logo resets the preview. */
$(document).on('cloudinarydone', '.cloudinary-fileupload', function() {
    setTimeout(function() {
        tlClearInteractiveLogoPreview();
        tlRefreshLogoPreviewAvailability();
    }, 100);
});


/* Logo On File / Add Logo Later / clear logo disable the uploaded-logo preview. */
$(document).on(
    'click',
    '.logo-on-file button, #upload-logo-later-button, .clear-existing-logo',
    function() {
        setTimeout(function() {
            tlClearInteractiveLogoPreview();
            tlRefreshLogoPreviewAvailability();
        }, 50);
    }
);


/* Keep preview aligned when customer changes gallery image or variant image. */
var tlGalleryObserverTimer = null;

function tlWatchProductGallery() {
    var gallery = document.querySelector('.product-gallery__carousel');

    if (!gallery) {
        return;
    }

    var observer = new MutationObserver(function() {
        if (!tlLogoPreview.active) {
            return;
        }

        clearTimeout(tlGalleryObserverTimer);

        tlGalleryObserverTimer = setTimeout(function() {
            tlSyncLogoPreview();
        }, 80);
    });

    observer.observe(gallery, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'src']
    });
}


/* Window resize / phone rotation. */
$(window).on('resize', function() {
    if (tlLogoPreview.active) {
        clearTimeout(tlGalleryObserverTimer);

        tlGalleryObserverTimer = setTimeout(
            tlSyncLogoPreview,
            100
        );
    }
});


/* Initialize preview UI. */
setTimeout(function() {
    tlEnsureLogoPreviewUI();
    tlRefreshLogoPreviewAvailability();
    tlWatchProductGallery();
}, 300);

});